<script setup lang="ts">
import Tag from "./detail/tag.vue";
import Region from "./detail/region.vue";
import Language from "./detail/language.vue";
import Manufacturer from "./detail/manufacturer.vue";
import Media from "./detail/media.vue";
import Release from "./detail/release.vue";
import Franchise from "./detail/franchise.vue";
import Gender from "./detail/gender.vue";

defineProps<{
  gameId: string;
}>();
</script>

<template>
  <section class="tab-game">
    <div class="content">
      <!-- Tags -->
      <Tag :game-id="gameId" />

      <!-- Regions -->
      <Region :game-id="gameId" />

      <!-- Languages -->
      <!-- <Language :game-id="gameId" /> -->

      <!-- Manufacturers -->
      <!-- <Manufacturer :game-id="gameId" /> -->

      <!-- medias -->
      <!-- <Media :game-id="gameId" /> -->

      <!-- Releases -->
      <!-- <Release :game-id="gameId" /> -->

      <!-- Franchises -->
      <!-- <Franchise :game-id="gameId" /> -->

      <!-- Genders -->
      <!-- <Gender :game-id="gameId" /> -->
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-game {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-game {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
